import { v4 } from 'uuid';
import createReducer from './create-reducer';

export default createReducer(
  {
    uuid: v4(),
  },
  {},
);
